<template>
  <div class="animated fadeIn">
    <b-row class="mt-4">
      <b-col md="2"></b-col>
      <b-col md="6"><h4>PRODUCT</h4></b-col>
      <b-col md="2"><h4>QUANTITY</h4></b-col>
      <b-col md="2"><h4>SUBTOTAL</h4></b-col>
    </b-row>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
